// src/common/security/session.js
// Oturum logunu otomatik kapatır (sekme kapanır/yenilenir/gizlenirse).
// Login'de upsertLoginSession'dan dönen sessionId -> setSessionId(id)

import { endLoginSession, FUNCTIONS_BASES } from "./api";

let _sessionId = null;
let _installed = false;
let _ended = false;

// sendBeacon tek hedef alıyor; burada PROD'u tercih ediyoruz.
// (Emülatör kullanıyorsan istersen aşağıdaki koşulu değiştir.)
const FUNCTIONS_BASE = FUNCTIONS_BASES.prod || FUNCTIONS_BASES.emu || "";

// Sekme kapanırken/yenilenirken logout’u kaçırmamak için beacon gönder.
function sendBeaconEnd() {
  if (!_sessionId || _ended || !FUNCTIONS_BASE) return;
  try {
    const url = `${FUNCTIONS_BASE}/endLoginSession`;
    const payload = JSON.stringify({ sessionId: _sessionId });
    const blob = new Blob([payload], { type: "application/json" });
    navigator.sendBeacon(url, blob);
    _ended = true;
  } catch {
    // yoksay
  }
}

function installAutoEnd() {
  if (_installed) return;
  _installed = true;
  window.addEventListener("beforeunload", sendBeaconEnd);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") sendBeaconEnd();
  });
}

// Dış API
export function setSessionId(id) {
  _sessionId = id || null;
  _ended = false;
  if (_sessionId) installAutoEnd();
}

export async function endSessionNow() {
  if (!_sessionId || _ended) return;
  try {
    await endLoginSession({ sessionId: _sessionId });
  } catch {
    // düşerse beacon devreye girecek
  } finally {
    _ended = true;
    _sessionId = null;
  }
}
